// import React, { Component } from "react";
// import {
//   Form,
//   Button,
//   Row,
//   Col,
//   Offcanvas,
//   Card,
//   Tooltip,
//   OverlayTrigger,
//   Table,
// } from "react-bootstrap";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import configData from "../config.json";
// import "./Integrationlibrary.css";

// export default class Integrationlibrary extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isEditing: false,
//       data: [],
//       sId: sessionStorage.getItem("sessionId"),
//       uId: sessionStorage.getItem("uId"),
//       Integrationtype: [],
//       AuthenticationMethods: [],
//       amFields: [],
//       amAFields: [],
//       errors: {},
//       filteredData: null,
//       tableClms: [
//         {
//           name: "S.NO",
//           selector: (row, i) => row.integrationlibrary_Id,
//           sortable: true,
//           cell: (row) => <span>{row.integrationlibrary_Id}</span>,
//         },
//         {
//           name: "Partner Name",
//           selector: (row, i) => row.partnerName,
//           sortable: true,
//           cell: (row) => <span>{row.partnerName}</span>,
//         },
//         {
//           name: "API Name",
//           selector: (row, i) => row.apiName,
//           sortable: true,
//           cell: (row) => <span>{row.apiName}</span>,
//         },
//         {
//           name: "API Description ",
//           selector: (row, i) => row.apiDescription,
//           sortable: true,
//           cell: (row) => <span>{row.apiDescription}</span>,
//         },
//         {
//           name: "IP/URL",
//           selector: (row, i) => row.ipUrl,
//           sortable: true,
//           cell: (row) => <span>{row.ipUrl}</span>,
//         },
//         {
//           name: "Authentication Method",
//           selector: (row, i) => row.authenticationMethod,
//           sortable: true,
//           cell: (row) => <span>{row.authenticationMethod}</span>,
//         },

//         {
//           name: "Actions",
//           sortable: false,
//           cell: (row) => (
//             <div>
//               {/* edit button and delete button */}
//               <Button
//                 style={{ marginRight: "10px" }}
//                 variant="primary"
//                 onClick={() => this.handleEditMode(row)}
//                 className="bi bi-pen"
//               ></Button>
//               <Button
//                 variant="danger"
//                 onClick={() => this.handleDelete(row)}
//                 className="bi bi-trash danger"
//               ></Button>
//             </div>
//           ),
//         },
//       ],
//       authenticationValue: {},
//       sendingHeader: [],
//       ExternalencryptionsSelect: [],
//       AuthenticationMethodKeys: {},
//       AuthenticationMethodAKeys: {},
//       AuthenticationMethodValues: {},
//       AuthenticationMethodAValues: {},
//       AuthenticationMethod: [],
//       SampleJSONrequest: [],
//       currentPage: 1,
//       itemsPerPage: 10,
//       partnerName: "",
//       apiName: "",
//       apiDescription: "",
//       ipUrl: "",
//       authenticationMethod: "",
//       token: "",
//       userName: "",
//       pwd: "",
//       throttleLimit: "",
//       type: "",
//       dummyOne: "",
//       dummyTwo: "",
//       dummyThree: "",
//       dummyFour: "",
//       dummyFive: "",
//       dummySix: "",
//       dummySeven: "",
//       dummyEight: "",
//       dummyNine: "",
//       dummyTen: "",
//       integrationlibrary_Id: "",
//       eeId: 0,
//       inputMethod: "",
//       headerData: {
//         key: "",
//         sampleValue: "",
//       },
//       jsonData: "",
//     };
//   }
//   AuthenticationmethodfetchHandler = () => {
//     var formData = new FormData();
//     formData.append("sId", this.state.sId);
//     formData.append("uId", this.state.uId);
//     fetch(configData.api_url + "C_Authenticationmethod/list", {
//       // Enter your IP address here

//       method: "POST",
//       //headers :{ 'Content-Type' : 'application/json'},
//       mode: "cors",
//       body: formData, // body data type must match "Content-Type" header
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         var AuthenticationMethodKeys = {};
//         var AuthenticationMethodAKeys = {};
//         if (data.status === "success") {
//           this.setState({ AuthenticationMethods: data.list });
//           var i = 0;
//           for (i = 0; i < data.list.length; i++) {
//             var amFields = [];
//             var amAFields = [];
//             if (data.list[i].amFields !== "") {
//               amFields = JSON.parse(JSON.parse(data.list[i].amFields));
//               // console.log(amFields, typeof amFields);
//             }
//             if (data.list[i].amAFields !== "") {
//               amAFields = JSON.parse(JSON.parse(data.list[i].amAFields));
//               // console.log(amAFields, typeof amAFields);
//             }
//             // [{ "fieldName": "Token", "fieldType": "text", "defaultValues": "" }];
//             // console.log(typeof amFields, "--", data.list[i].methodName);
//             AuthenticationMethodKeys[data.list[i].methodName] = amFields;
//             AuthenticationMethodAKeys[data.list[i].methodName] = amAFields;
//             // console.log(AuthenticationMethodKeys);
//             // console.log(AuthenticationMethodAKeys);
//           }
//           this.setState({
//             AuthenticationMethodKeys: AuthenticationMethodKeys,
//             AuthenticationMethodAKeys: AuthenticationMethodAKeys,
//           });
//         }
//       });
//   };
//   // handleEditMode = (row) => {
//   //   // this.setState({ cData: { ...row }, isEditing: true });
//   //   var formData = new FormData();
//   //   formData.append("sId", this.state.sId);
//   //   formData.append("uId", this.state.uId);
//   //   this.setState({
//   //     type: row.type,
//   //     partnerName: row.partnerName,
//   //     ipUrl: row.ipUrl,
//   //     amValues: row.amValues,
//   //     apiName: row.apiName,
//   //     inputMethod: row.inputMethod,
//   //     authenticationMethod: row.authenticationMethod,
//   //     eeId: row.eeId,
//   //     inputHeaders: row.inputHeaders,
//   //     integrationlibrary_Id: row.integrationlibrary_Id,
//   //     apiDescription: row.apiDescription,
//   //     isEditing: true,
//   //   });
//   // };
//   handleEditMode = (row) => {
//     const integrationlibrary_Id = row.integrationlibrary_Id;
//     sessionStorage.setItem("isNewEntry", "false");

//     sessionStorage.setItem("integrationlibrary_Id", integrationlibrary_Id);
//     window.location.href = "/integration_library";
//   };
//   // offcanvas Open

//   // Offcanvas close button
//   handleOffcanvasClose = () => {
//     this.setState({ isEditing: false });
//   };
//   showToast = (msg, type) => {
//     switch (type) {
//       case "success":
//         toast.success(msg);
//         break;
//       case "error":
//         toast.error(msg);
//         break;
//       case "warning":
//         toast.warn(msg); // 'warn' is used instead of 'warning'
//         break;
//       default:
//         toast.info(msg);
//     }
//   };

//   // header functionality
//   keyvalidatehr() {
//     const { currentStep, headerData } = this.state;
//     let formIsValid = true;
//     if (!headerData["key"]) {
//       formIsValid = false;
//       toast.info("*Enter Header Key.");
//     } else if (!headerData["sampleValue"]) {
//       formIsValid = false;
//       toast.info("*Enter Header Sample value.");
//     } else {
//       // If all fields are filled, proceed to the next step
//       this.setState({ currentStep: currentStep + 1 });
//     }
//     return formIsValid;
//   }
//   handleRemoveSpecificRowHeader = (idx) => {
//     const tempRows = this.state.sendingHeader; // to avoid  direct state mutation
//     tempRows.splice(idx, 1);
//     this.setState({ sendingHeader: tempRows });
//   };
//   handleEditInputChangeHeader(index, field, value) {
//     const updatedHeader = [...this.state.sendingHeader];
//     updatedHeader[index][field] = value;
//     // this.getColumns(value, "rcolumns");
//     this.setState({ sendingHeader: updatedHeader });
//   }
//   inputSHrChange = (e) => {
//     e.preventDefault();
//     const fieldName = e.target.getAttribute("name");
//     const fieldValue = e.target.value;
//     const inputData = this.state.headerData;

//     inputData[fieldName] = fieldValue;
//     this.setState({ headerData: inputData });
//     console.log(this.state.headerData);
//   };
//   IntegrationlibraryeditHandler = (e) => {
//     e.preventDefault();
//     // const updateFormData = {...editFormData};
//     // updateFormData['Integrationlibrary_Id'] = e.target.parentElement.getAttribute("id");
//     // setEditFormData(updateFormData);
//     // setEdit(true);
//   };
//   renderTooltip = (text) => <Tooltip id="button-tooltip">{text}</Tooltip>;
//   IntegrationlibraryfetchHandler = () => {
//     var formData = new FormData();
//     formData.append("sId", this.state.sId);
//     formData.append("uId", this.state.uId);
//     fetch(configData.api_url + "C_Integrationlibrary/list", {
//       // Enter your IP address here

//       method: "POST",
//       //headers :{ 'Content-Type' : 'application/json'},
//       mode: "cors",
//       body: formData, // body data type must match "Content-Type" header
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "success") {
//           this.setState({ data: data.list });
//         }
//       });
//   };
//   handledummyOneChange = (e) => {
//     e.preventDefault();

//     const fieldValue = e.target.value;

//     this.setState({ dummyOne: fieldValue });
//   };
//   IntegrationlibrarysubmitHandler = (e) => {
//     e.preventDefault();
//     var amValues = this.state.AuthenticationMethodValues;
//     this.setState({ isSubmitted: true });
//     //   setButtons(contacts);
//     var formData = new FormData();
//     formData.append("sId", this.state.sId);
//     formData.append("uId", this.state.uId);
//     formData.append("integrationlibrary_Id", this.state.integrationlibrary_Id);
//     formData.append("partnerName", this.state.partnerName);
//     formData.append("apiName", this.state.apiName);
//     formData.append("apiDescription", this.state.apiDescription);
//     formData.append("ipUrl", this.state.ipUrl);
//     formData.append("authenticationMethod", this.state.authenticationMethod);
//     formData.append("amValues", JSON.stringify(amValues));
//     formData.append("type", this.state.type);
//     formData.append("inputMethod", this.state.inputMethod);
//     formData.append("inputHeaders", JSON.stringify(this.state.sendingHeader));
//     formData.append("dummyOne", this.state.dummyOne);
//     formData.append("dummyTwo", "");
//     formData.append("dummyThree", "");
//     formData.append("dummyFour", "");
//     formData.append("dummyFive", "");
//     formData.append("dummySix", "");
//     formData.append("dummySeven", "");
//     formData.append("dummyEight", "");
//     formData.append("dummyNine", "");
//     formData.append("dummyTen", "");
//     fetch(configData.api_url + "C_Integrationlibrary/update", {
//       // Enter your IP address here

//       method: "POST",
//       //headers :{ 'Content-Type' : 'application/json'},
//       mode: "cors",
//       body: formData, // body data type must match "Content-Type" header
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         this.showToast(data.message, data.status);
//         if (data.status === "success") {
//           setTimeout(() => {
//             window.location.href = "/requestjson";
//           }, 1500);

//           sessionStorage.setItem(
//             "integrationlibrary_Id",
//             data.integrationlibrary_Id
//           );
//           this.IntegrationlibraryfetchHandler();

//           this.setState({
//             integrationlibrary_Id: data.integrationlibrary_Id,
//             partnerName: "",
//             apiName: "",
//             apiDescription: "",
//             ipUrl: "",
//             authenticationMethod: "",

//             type: "",
//           });
//         }
//       });
//   };
//   IntegrationlibraryupdateHandler = (e) => {
//     e.preventDefault();
//     var formData = new FormData();
//     formData.append("sId", this.state.sId);
//     formData.append("uId", this.state.uId);
//     formData.append("partnerName", this.state.partnerName);
//     formData.append("apiName", this.state.apiName);
//     formData.append("apiDescription", this.state.apiDescription);
//     formData.append("ipUrl", this.state.ipUrl);
//     formData.append("authenticationMethod", this.state.authenticationMethod);
//     formData.append("token", this.state.token);
//     formData.append("userName", this.state.userName);
//     formData.append("pwd", this.state.pwd);
//     formData.append("throttleLimit", this.state.throttleLimit);
//     formData.append("type", this.state.type);
//     formData.append("dummyOne", this.state.dummyOne);
//     formData.append("dummyTwo", this.state.dummyTwo);
//     formData.append("dummyThree", this.state.dummyThree);
//     formData.append("dummyFour", this.state.dummyFour);
//     formData.append("dummyFive", this.state.dummyFive);
//     formData.append("dummySix", this.state.dummySix);
//     formData.append("dummySeven", this.state.dummySeven);
//     formData.append("dummyEight", this.state.dummyEight);
//     formData.append("dummyNine", this.state.dummyNine);
//     formData.append("dummyTen", this.state.dummyTen);

//     fetch(configData.api_url + "C_Integrationlibrary/update", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         this.showToast(data.message, data.status);
//         if (data.status === "success") {
//           this.IntegrationlibraryfetchHandler();
//           this.handleOffcanvasClose();
//         }
//       });
//   };
//   IntegrationtypemastersfetchHandler = () => {
//     var formData = new FormData();

//     formData.append("sId", this.state.sId);

//     formData.append("uId", this.state.uId);

//     fetch(configData.api_url + "C_Integrationtypemasters/list", {
//       // Enter your IP address here

//       method: "POST",

//       //headers :{ 'Content-Type' : 'application/json'},

//       mode: "cors",

//       body: formData, // body data type must match "Content-Type" header
//     })
//       .then((response) => response.json())

//       .then((data) => {
//         if (data.status === "success") {
//           this.setState({ Integrationtype: data.list });
//         }
//       });
//   };
//   IntegrationlibraryfetchHandlerSaveJson = () => {
//     var formData = new FormData();
//     formData.append("sId", this.state.sId);
//     formData.append("uId", this.state.uId);
//     fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
//       method: "POST",
//       mode: "cors",
//       body: {},
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.status === "success") {
//           this.setState({ data: data.list });
//         }
//       });
//   };

//   componentDidMount() {
//     this.IntegrationlibraryfetchHandler();
//     this.IntegrationtypemastersfetchHandler();
//     this.AuthenticationmethodfetchHandler();
//     this.IntegrationlibraryfetchHandlerSaveJson();
//   }
//   handleinputMethodChange = (e) => {
//     e.preventDefault();

//     const fieldValue = e.target.value;

//     this.setState({ inputMethod: fieldValue });
//   };

//   handlepartnerNameChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ partnerName: fieldValue });
//   };
//   handleapiNameChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ apiName: fieldValue });
//   };
//   handleapiDescriptionChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ apiDescription: fieldValue });
//   };
//   handleipUrlChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ ipUrl: fieldValue });
//   };
//   handleauthenticationMethodChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     const amFields = this.state.AuthenticationMethodKeys[fieldValue];
//     const amAFields = this.state.AuthenticationMethodAKeys[fieldValue];
//     var AuthenticationMethodValues = {};
//     var AuthenticationMethodAValues = {};
//     amFields.forEach(function (key, index) {
//       console.log(key);
//       console.log(key["fieldName"]);
//       AuthenticationMethodValues[key["fieldName"]] = "";
//     });
//     amAFields.forEach(function (key, index) {
//       console.log(key);
//       console.log(key["fieldName"]);
//       AuthenticationMethodAValues[key["fieldName"]] = "";
//     });
//     console.log(AuthenticationMethodValues);
//     console.log(AuthenticationMethodAValues);
//     this.setState({
//       authenticationMethod: fieldValue,
//       amFields: amFields,
//       amAFields: amAFields,
//     });
//   };
//   handleJsonChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ jsonData: fieldValue });
//   };
//   generatePalceholder = (value1, value2) => {
//     let returnValue = value1 + value2;
//     // console.log(returnValue);
//     return returnValue;
//   };
//   handletokenChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ token: fieldValue });
//   };
//   handleuserNameChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ userName: fieldValue });
//   };
//   handlepwdChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ pwd: fieldValue });
//   };
//   handlethrottleLimitChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ throttleLimit: fieldValue });
//   };
//   handletypeChange = (e) => {
//     e.preventDefault();
//     const fieldValue = e.target.value;
//     this.setState({ type: fieldValue });
//   };
//   handleRowSelect = (row) => {
//     this.setState({
//       selectedRow: row.index,
//     });
//   };

//   handleRowUpdate = (newData, oldData) => {
//     const data = [...this.state.data];
//     const index = oldData.index;
//     data[index] = newData;
//     this.setState({ data });
//   };

//   handleDelete = (row, index) => {
//     var formData = new FormData();
//     formData.append("sId", this.state.sId);
//     formData.append("uId", this.state.uId);
//     formData.append("integrationlibrary_Id", row.integrationlibrary_Id);
//     fetch(configData.api_url + "C_Integrationlibrary/delete", {
//       method: "POST",
//       mode: "cors",
//       body: formData,
//     })
//       .then((response) => response.json())
//       .then((data) => {
//         this.showToast(data.message, data.status);
//         if (data.status === "success") {
//           this.IntegrationlibraryfetchHandler();
//         }
//       });
//   };
//   handlePageChange = (page) => {
//     this.setState({ currentPage: page });
//   };

//   handlePerRowsChange = (newPerPage, page) => {
//     this.setState({ itemsPerPage: newPerPage, currentPage: page });
//   };

//   handleFilter = (e) => {
//     const searchValue = e.target.value.toLowerCase();
//     const filteredData = this.state.data.filter((row) => {
//       return Object.values(row).join(" ").toLowerCase().includes(searchValue);
//     });
//     this.setState({ filteredData });
//   };
//   handleSubmitBackClick = (e) => {
//     sessionStorage.setItem("isNewEntry", "true");
//     window.location.href = "/integration_library";
//   };
//   handleinputAChange(fieldName, fieldType, fieldValue) {
//     const AuthenticationMethodValues = this.state.AuthenticationMethodValues;
//     fieldType = fieldName;
//     AuthenticationMethodValues[fieldName] = fieldValue;
//     this.setState({ AuthenticationMethodValues: AuthenticationMethodValues });
//   }
//   handleinputAAChange(fieldName, fieldType, fieldValue) {
//     const AuthenticationMethodAValues = this.state.AuthenticationMethodAValues;
//     fieldType = fieldName;
//     AuthenticationMethodAValues[fieldName] = fieldValue;
//     this.setState({ AuthenticationMethodAValues: AuthenticationMethodAValues });
//   }

//   render() {
//     const paginatedData = this.state.filteredData
//       ? this.state.filteredData.slice(
//           (this.state.currentPage - 1) * this.state.itemsPerPage,
//           this.state.currentPage * this.state.itemsPerPage
//         )
//       : this.state.data.slice(
//           (this.state.currentPage - 1) * this.state.itemsPerPage,
//           this.state.currentPage * this.state.itemsPerPage
//         );
//     // const { isSubmitted } = this.state;
//     return (
//       <div className="page-title">
//         <Row>
//           <Col xs={4} sm={4} lg={4}>
//             <OverlayTrigger
//               placement="top"
//               overlay={this.renderTooltip("Integration Library")}
//             >
//               <Card className="nav-card active-step">
//                 <span className="bi bi-boxes nav-icon"></span>
//                 <p className="nav-label">Integration Library</p>
//               </Card>
//             </OverlayTrigger>
//           </Col>

//           <Col xs={4} sm={4} lg={4}>
//             <OverlayTrigger
//               placement="top"
//               overlay={this.renderTooltip("Request JSON")}
//             >
//               <Card
//                 className="nav-card "
//                 onClick={() => this.setState({ step: 2 })}
//               >
//                 <span className="bi bi-journal-album nav-icon"></span>
//                 <p className="nav-label">Request JSON</p>
//               </Card>
//             </OverlayTrigger>
//           </Col>

//           <Col xs={4} sm={4} lg={4}>
//             <OverlayTrigger
//               placement="top"
//               overlay={this.renderTooltip("Response JSON")}
//             >
//               <Card
//                 className="nav-card"
//                 onClick={() => this.setState({ step: 3 })}
//               >
//                 <span className="bi bi-table nav-icon"></span>
//                 <p className="nav-label">Response JSON</p>
//               </Card>
//             </OverlayTrigger>
//           </Col>
//         </Row>
//         <br />
//         <div className="row">
//           <div className="col-md-12 col-sm-12 col-xs-12">
//             <div className="x_panel">
//               <div className="x_content">
//                 <div
//                   id="datatable_wrapper"
//                   className="dataTables_wrapper form-inline
//                 dt-bootstrap no-footer"
//                 >
//                   <Row className="row">
//                     <div>
//                       <h3
//                         className="logoskybluecolor"
//                         style={{ textAlign: "start" }}
//                       >
//                         Integration Library
//                       </h3>
//                     </div>
//                     <Col
//                       className="d-flex justify-content-end"
//                       style={{ marginRight: "5px", marginTop: "20px" }}
//                     >
//                       {this.state.isEditing && (
//                         <Offcanvas
//                           show={this.state.isEditing}
//                           onHide={() => this.setState({ isEditing: false })}
//                           {...this.props}
//                           style={{ width: "500px" }}
//                           placement="end"
//                           backdrop="true"
//                         >
//                           <Offcanvas.Header closeButton>
//                             <Offcanvas.Title>
//                               Integrationlibrary page
//                             </Offcanvas.Title>
//                           </Offcanvas.Header>
//                           <Offcanvas.Body>
//                             <Row className="divstyle">
//                               <Row>
//                                 <Form>
//                                   <Row>
//                                     <Col lg="4" md="4">
//                                       <Form.Label style={{ paddingTop: "8px" }}>
//                                         Partner Name
//                                       </Form.Label>
//                                     </Col>
//                                     <Col lg="8" md="8">
//                                       <Form.Control
//                                         type="text"
//                                         onChange={this.handlepartnerNameChange}
//                                         className="form-control"
//                                         name="partnerName"
//                                         value={this.state.partnerName}
//                                         required="required"
//                                         placeholder="Enter Partner Name"
//                                       />
//                                     </Col>
//                                   </Row>
//                                   <br />
//                                   <Row>
//                                     <Col lg="4" md="4">
//                                       <Form.Label style={{ paddingTop: "8px" }}>
//                                         API Name
//                                       </Form.Label>
//                                     </Col>
//                                     <Col lg="8" md="8">
//                                       <Form.Control
//                                         //disabled={isSubmitted}
//                                         type="text"
//                                         onChange={this.handleapiNameChange}
//                                         className="form-control"
//                                         name="apiName"
//                                         value={this.state.apiName}
//                                         required="required"
//                                         placeholder="Enter API Name"
//                                       />
//                                     </Col>
//                                   </Row>
//                                   <br />
//                                   <Row>
//                                     <Col lg="4" md="4">
//                                       <Form.Label style={{ paddingTop: "8px" }}>
//                                         API Description
//                                       </Form.Label>
//                                     </Col>
//                                     <Col lg="8" md="8">
//                                       <Form.Control
//                                         //disabled={isSubmitted}
//                                         type="text"
//                                         onChange={
//                                           this.handleapiDescriptionChange
//                                         }
//                                         className="form-control"
//                                         name="apiDescription"
//                                         value={this.state.apiDescription}
//                                         required="required"
//                                         placeholder="Enter API Description "
//                                       />
//                                     </Col>
//                                   </Row>
//                                   <br />
//                                   <Row>
//                                     <Col lg="4" md="4">
//                                       <Form.Label style={{ paddingTop: "8px" }}>
//                                         IP/URL
//                                       </Form.Label>
//                                     </Col>
//                                     <Col lg="8" md="8">
//                                       <Form.Control
//                                         //disabled={isSubmitted}
//                                         type="text"
//                                         onChange={this.handleipUrlChange}
//                                         className="form-control"
//                                         name="ipUrl"
//                                         value={this.state.ipUrl}
//                                         required="required"
//                                         placeholder="Enter IP/URL"
//                                       />
//                                     </Col>
//                                   </Row>
//                                   <br />
//                                   <Row>
//                                     <Col lg="4" md="4">
//                                       <Form.Label style={{ paddingTop: "8px" }}>
//                                         Integration Type
//                                       </Form.Label>
//                                     </Col>
//                                     <Col lg="8" md="8">
//                                       <Form.Control
//                                         // disabled={isSubmitted}
//                                         as="select"
//                                         onChange={this.handletypeChange}
//                                         className="form-select"
//                                         name="type"
//                                         value={this.state.type}
//                                         required="required"
//                                         placeholder="Enter Type"
//                                       >
//                                         <option defaultValue>
//                                           Select Integration Type
//                                         </option>
//                                         {this.state.Integrationtype.map(
//                                           (api, index, idx) => (
//                                             <option
//                                               key={index}
//                                               value={api.typeName}
//                                             >
//                                               {api.typeName}
//                                             </option>
//                                           )
//                                         )}
//                                       </Form.Control>
//                                     </Col>
//                                   </Row>
//                                   <br />
//                                   <Row>
//                                     <Col lg="4" md="4">
//                                       <Form.Label style={{ paddingTop: "8px" }}>
//                                         Authentication Type
//                                       </Form.Label>
//                                     </Col>
//                                     <Col lg="8" md="8">
//                                       <Form.Control
//                                         // disabled={isSubmitted}
//                                         as="select"
//                                         onChange={
//                                           this.handleauthenticationMethodChange
//                                         }
//                                         className="form-select"
//                                         name="authenticationMethod"
//                                         value={this.state.authenticationMethod}
//                                         required="required"
//                                       >
//                                         <option defaultValue>
//                                           Select Type
//                                         </option>
//                                         {this.state.AuthenticationMethods.map(
//                                           (api, index, idx) => (
//                                             <option
//                                               key={index}
//                                               value={api.methodName}
//                                             >
//                                               {api.methodName}
//                                             </option>
//                                           )
//                                         )}
//                                       </Form.Control>
//                                     </Col>
//                                   </Row>
//                                   <br />
//                                   <Row>
//                                     <Col lg="4" md="4">
//                                       <Form.Label style={{ paddingTop: "8px" }}>
//                                         Select Method
//                                       </Form.Label>
//                                     </Col>
//                                     <Col lg="8" md="8">
//                                       <Form.Select
//                                         aria-label="Default select example"
//                                         name="inputMethod"
//                                         value={this.state.inputMethod}
//                                         onChange={this.handleinputMethodChange}
//                                       >
//                                         <option>Select method</option>
//                                         <option value="GET">GET</option>
//                                         <option value="POST">POST</option>
//                                         <option value="PUT">PUT</option>
//                                         <option value="PATCH">PATCH</option>
//                                         <option value="DELETE">DELETE</option>
//                                         <option value="LINK">LINK</option>
//                                         <option value="LINK">UNLINK</option>
//                                         <option value="HEAD">HEAD</option>
//                                         <option value="PURGE">PURGE</option>
//                                         <option value="LOCK">LOCK</option>
//                                         <option value="UNLOCK">UNLOCK</option>
//                                       </Form.Select>
//                                     </Col>
//                                     <div
//                                       className="errorMsg"
//                                       style={{ color: "red" }}
//                                     >
//                                       {" "}
//                                       {this.state.errors.dummyThree}{" "}
//                                     </div>
//                                   </Row>
//                                   <br />
//                                   {this.state.amFields.length > 0 ? (
//                                     <Card>
//                                       <Row>
//                                         <Col>
//                                           <div className="row">
//                                             {this.state.amFields.map(
//                                               (api, index, idx) => (
//                                                 <div
//                                                   className="col-md-4 col-lg-6"
//                                                   key={idx}
//                                                 >
//                                                   <Form.Label
//                                                     style={{
//                                                       paddingTop: "8px",
//                                                     }}
//                                                   >
//                                                     {api.labelName}
//                                                   </Form.Label>
//                                                   {api.fieldType ===
//                                                   "checkbox" ? (
//                                                     <Form.Check
//                                                       type={api.fieldType}
//                                                       className="form-check"
//                                                       name={api.fieldName}
//                                                       onChange={(e) =>
//                                                         this.handleinputAChange(
//                                                           api.fieldName,
//                                                           api.fieldType,
//                                                           e.target.value
//                                                         )
//                                                       }
//                                                       placeholder={this.generatePalceholder(
//                                                         "Enter ",
//                                                         api.labelName
//                                                       )}
//                                                     />
//                                                   ) : api.fieldType !==
//                                                     "select" ? (
//                                                     <Form.Control
//                                                       type={api.fieldType}
//                                                       className="form-control"
//                                                       name={api.fieldName}
//                                                       onChange={(e) =>
//                                                         this.handleinputAChange(
//                                                           api.fieldName,
//                                                           api.fieldType,
//                                                           e.target.value
//                                                         )
//                                                       }
//                                                       placeholder={this.generatePalceholder(
//                                                         "Enter ",
//                                                         api.labelName
//                                                       )}
//                                                     />
//                                                   ) : (
//                                                     <Form.Control
//                                                       as={api.fieldType}
//                                                       className="form-select"
//                                                       placeholder={this.generatePalceholder(
//                                                         "Select ",
//                                                         api.fieldName
//                                                       )}
//                                                       value={
//                                                         this.state
//                                                           .AuthenticationMethodAValues[
//                                                           api.fieldName
//                                                         ]
//                                                       } // Assuming 'token' is the state variable for the text box
//                                                       onChange={(e) =>
//                                                         this.handleinputAChange(
//                                                           api.fieldName,
//                                                           api.fieldType,
//                                                           e.target.value
//                                                         )
//                                                       } // Update the token value in state
//                                                     >
//                                                       {api.defaultValues
//                                                         .split(",")
//                                                         .map((line) => (
//                                                           <option value={line}>
//                                                             {line}
//                                                           </option>
//                                                         ))}
//                                                     </Form.Control>
//                                                   )}
//                                                   <br />
//                                                 </div>
//                                               )
//                                             )}
//                                           </div>
//                                         </Col>
//                                       </Row>
//                                     </Card>
//                                   ) : (
//                                     ""
//                                   )}
//                                   {this.state.amAFields.length > 0 ? (
//                                     <Card>
//                                       <Row>
//                                         <Col>
//                                           <div className="row">
//                                             {this.state.amAFields.map(
//                                               (api, index, idx) => (
//                                                 <div className="col-md-4 col-lg-6">
//                                                   <Form.Label
//                                                     style={{
//                                                       paddingTop: "8px",
//                                                     }}
//                                                   >
//                                                     {api.fieldName} --{" "}
//                                                     {api.fieldName}
//                                                   </Form.Label>
//                                                   {api.fieldType ===
//                                                   "checkbox" ? (
//                                                     <Form.Check
//                                                       checked={
//                                                         this.state
//                                                           .AuthenticationMethodAValues[
//                                                           api.fieldName
//                                                         ] || false
//                                                       }
//                                                       type="checkbox"
//                                                       className="form-check"
//                                                       name={api.fieldName}
//                                                       onChange={(e) =>
//                                                         this.handleinputAAChange(
//                                                           api.fieldName,
//                                                           api.fieldType,
//                                                           e.target.checked
//                                                         )
//                                                       }
//                                                       placeholder={this.generatePalceholder(
//                                                         "Enter ",
//                                                         api.fieldName
//                                                       )}
//                                                     />
//                                                   ) : api.fieldType !==
//                                                     "select" ? (
//                                                     <Form.Control
//                                                       type={api.fieldType}
//                                                       className="form-control"
//                                                       name={api.fieldName}
//                                                       onChange={(e) =>
//                                                         this.handleinputAAChange(
//                                                           api.fieldName,
//                                                           api.fieldType,
//                                                           e.target.value
//                                                         )
//                                                       }
//                                                       placeholder={this.generatePalceholder(
//                                                         "Enter ",
//                                                         api.fieldName
//                                                       )}
//                                                     />
//                                                   ) : (
//                                                     <Form.Control
//                                                       as={api.fieldType}
//                                                       className="form-select"
//                                                       placeholder={this.generatePalceholder(
//                                                         "Select ",
//                                                         api.fieldName
//                                                       )}
//                                                       value={
//                                                         this.state
//                                                           .AuthenticationMethodAValues[
//                                                           api.fieldName
//                                                         ]
//                                                       } // Assuming 'token' is the state variable for the text box
//                                                       onChange={(e) =>
//                                                         this.handleinputAAChange(
//                                                           api.fieldName,
//                                                           api.fieldType,
//                                                           e.target.value
//                                                         )
//                                                       } // Update the token value in state
//                                                     >
//                                                       {api.defaultValues
//                                                         .split(",")
//                                                         .map((line) => (
//                                                           <option value={line}>
//                                                             {line}
//                                                           </option>
//                                                         ))}
//                                                     </Form.Control>
//                                                   )}
//                                                   <br />
//                                                 </div>
//                                               )
//                                             )}
//                                           </div>
//                                         </Col>
//                                       </Row>
//                                     </Card>
//                                   ) : (
//                                     ""
//                                   )}
//                                   <br />{" "}
//                                   <Card>
//                                     <Card.Header>Headers</Card.Header>
//                                     <Card.Body>
//                                       <Table
//                                         className="table table-bordered table-hover"
//                                         id="tab_logic"
//                                       >
//                                         <thead>
//                                           <tr>
//                                             <th className="text-center">
//                                               S.NO
//                                             </th>
//                                             <th className="text-center">KEY</th>

//                                             <th className="text-center">
//                                               Sample
//                                             </th>
//                                             <th className="text-center">
//                                               Actions
//                                             </th>
//                                           </tr>
//                                         </thead>
//                                         <tbody>
//                                           {this.state.sendingHeader.length >
//                                           0 ? (
//                                             this.state.sendingHeader.map(
//                                               (api, index, idx) => (
//                                                 <tr key={index}>
//                                                   <td>{index + 1}</td>
//                                                   <td>
//                                                     {this.state.editingIndex ===
//                                                     index ? (
//                                                       <Form.Control
//                                                         type="Text"
//                                                         value={api.key}
//                                                         onChange={(e) =>
//                                                           this.handleEditInputChangeHeader(
//                                                             index,
//                                                             "key",
//                                                             e.target.value
//                                                           )
//                                                         }
//                                                       />
//                                                     ) : (
//                                                       api.key
//                                                     )}
//                                                   </td>

//                                                   <td>
//                                                     {this.state.editingIndex ===
//                                                     index ? (
//                                                       <Form.Control
//                                                         type="Text"
//                                                         name="sampleValue"
//                                                         placeholder="Sample"
//                                                         value={api.sampleValue}
//                                                         onChange={(e) =>
//                                                           this.handleEditInputChangeHeader(
//                                                             index,
//                                                             "sampleValue",
//                                                             e.target.value
//                                                           )
//                                                         }
//                                                       />
//                                                     ) : (
//                                                       api.sampleValue
//                                                     )}
//                                                   </td>
//                                                   <td>
//                                                     {this.state.editingIndex !==
//                                                       index && ( // Condition to render Add button above the row being edited
//                                                       <button
//                                                         variant="danger"
//                                                         className="bi bi-trash-fill btn btn-danger"
//                                                         onClick={() =>
//                                                           this.handleRemoveSpecificRowHeader(
//                                                             index
//                                                           )
//                                                         }
//                                                       ></button>
//                                                     )}
//                                                   </td>
//                                                 </tr>
//                                               )
//                                             )
//                                           ) : (
//                                             <tr>
//                                               <td colSpan="6"> No Records</td>
//                                             </tr>
//                                           )}
//                                           <tr>
//                                             <td>---</td>
//                                             <td>
//                                               <Form.Control
//                                                 type="Text"
//                                                 name="key"
//                                                 placeholder="Key Value"
//                                                 value={
//                                                   this.state.headerData.key
//                                                 }
//                                                 onChange={this.inputSHrChange}
//                                               />
//                                               <div
//                                                 className="errorMsg"
//                                                 style={{ color: "red" }}
//                                               >
//                                                 {this.state.errors.key}
//                                               </div>
//                                             </td>

//                                             <td>
//                                               <Form.Control
//                                                 type="Text"
//                                                 name="sampleValue"
//                                                 placeholder="Sample Value"
//                                                 value={
//                                                   this.state.headerData
//                                                     .sampleValue
//                                                 }
//                                                 onChange={this.inputSHrChange}
//                                               />
//                                             </td>
//                                             <td>
//                                               <Button
//                                                 type="button"
//                                                 variant="success"
//                                                 // className="bi bi-plus"
//                                                 onClick={this.addSendhrRow}
//                                               >
//                                                 Add
//                                               </Button>
//                                             </td>
//                                           </tr>
//                                         </tbody>
//                                       </Table>
//                                     </Card.Body>
//                                   </Card>{" "}
//                                 </Form>
//                               </Row>
//                             </Row>
//                             <Row>
//                               <Col
//                                 className="d-flex justify-content-end"
//                                 style={{ marginRight: "50px" }}
//                               >
//                                 <Button
//                                   className="button"
//                                   variant="success"
//                                   onClick={this.IntegrationlibrarysubmitHandler}
//                                   style={{
//                                     marginTop: "20px",
//                                   }}
//                                 >
//                                   Update
//                                 </Button>
//                               </Col>
//                             </Row>
//                           </Offcanvas.Body>
//                         </Offcanvas>
//                       )}
//                       {/*offcanvas is over */}
//                     </Col>
//                   </Row>
//                   <br />
//                   <Row>
//                     <div style={{ marginRight: "5px" }}>
//                       {/* searchbar,pagination,filter */}
//                       <input
//                         type="text"
//                         style={{ float: "left", marginBottom: "10px" }}
//                         onChange={this.handleFilter}
//                         placeholder="Search..."
//                       />
//                       <Button
//                         variant="primary"
//                         className="bi bi-plus "
//                         onClick={this.handleSubmitBackClick}
//                         style={{ float: "right", marginBottom: "10px" }}
//                       >
//                         New
//                       </Button>
//                       <DataTable
//                         data={paginatedData}
//                         columns={this.state.tableClms}
//                         pagination
//                         paginationServer
//                         paginationTotalRows={
//                           this.state.filteredData
//                             ? this.state.filteredData.length
//                             : this.state.data.length
//                         }
//                         paginationRowsPerPageOptions={[
//                           10, 20, 30, 50, 60, 70, 80, 90, 100, 150, 200,
//                         ]}
//                         onChangeRowsPerPage={this.handlePerRowsChange}
//                         onChangePage={this.handlePageChange}
//                         paginationPerPage={this.state.itemsPerPage}
//                         keyField="id"
//                         className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
//                       />
//                     </div>
//                   </Row>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }
import React, { Component } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  Offcanvas,
  Card,
  Tooltip,
  OverlayTrigger,
  Table,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import "./Integrationlibrary.css";

export default class Integrationlibrary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      Integrationtype: [],
      AuthenticationMethods: [],
      amFields: [],
      amAFields: [],
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.integrationlibrary_Id,
          sortable: true,
          cell: (row) => <span>{row.integrationlibrary_Id}</span>,
        },
        {
          name: "Partner Name",
          selector: (row, i) => row.partnerName,
          sortable: true,
          cell: (row) => <span>{row.partnerName}</span>,
        },
        {
          name: "API Name",
          selector: (row, i) => row.apiName,
          sortable: true,
          cell: (row) => <span>{row.apiName}</span>,
        },
        {
          name: "API Description ",
          selector: (row, i) => row.apiDescription,
          sortable: true,
          cell: (row) => <span>{row.apiDescription}</span>,
        },
        {
          name: "IP/URL",
          selector: (row, i) => row.ipUrl,
          sortable: true,
          cell: (row) => <span>{row.ipUrl}</span>,
        },
        {
          name: "Authentication Method",
          selector: (row, i) => row.authenticationMethod,
          sortable: true,
          cell: (row) => <span>{row.authenticationMethod}</span>,
        },

        {
          name: "Integration ID",
          selector: (row, i) => row.integrationlibrary_Id,
          sortable: true,
          cell: (row) => <span>{row.integrationlibrary_Id}</span>,
        },
        {
          name: "Request ID",
          selector: (row, i) => row.responseId,
          sortable: true,
          cell: (row) => <span>{row.responseId}</span>,
        },
        {
          name: "Response ID",
          selector: (row, i) => row.responseId,
          sortable: true,
          cell: (row) => <span>{row.responseId}</span>,
        },
        {
          name: "Request  File",
          id: "filePath",
          selector: (row) => row.filePath,
          sortable: true,
          cell: (row) => (
            <span>
              {" "}
              <Button
                onClick={(e) => this.Handledowloadcsv(e, row)}
                className="bi bi-arrow-down mt-0"
                style={{
                  marginRight: "3px",
                  backgroundColor: "#ffeaac",
                  borderRadius: "0px",
                }}
              ></Button>
            </span>
          ),
        },
        {
          name: "Response File",
          id: "filePath",
          selector: (row) => row.filePath, // Ensure 'insurerName' exists in the data
          sortable: true,
          cell: (row) => (
            <span>
              {" "}
              <Button
                variant="warning"
                onClick={(e) => this.handleResponseDownload(e, row)}
                className="bi bi-arrow-down   mt-0"
                style={{
                  marginRight: "3px",
                  backgroundColor: "#48bff1",
                  borderRadius: "0px",
                }}
              ></Button>
            </span>
          ),
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.handleEditMode(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      authenticationValue: {},
      sendingHeader: [],
      ExternalencryptionsSelect: [],
      AuthenticationMethodKeys: {},
      AuthenticationMethodAKeys: {},
      AuthenticationMethodValues: {},
      AuthenticationMethodAValues: {},
      AuthenticationMethod: [],
      SampleJSONrequest: [],
      currentPage: 1,
      itemsPerPage: 10,
      partnerName: "",
      apiName: "",
      apiDescription: "",
      ipUrl: "",
      authenticationMethod: "",
      token: "",
      userName: "",
      pwd: "",
      throttleLimit: "",
      type: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      dummySix: "",
      dummySeven: "",
      dummyEight: "",
      dummyNine: "",
      dummyTen: "",
      integrationlibrary_Id: "",
      eeId: 0,
      inputMethod: "",
      headerData: {
        key: "",
        sampleValue: "",
      },
      jsonData: "",
    };
  }
  handleResponseDownload = (e, row) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", row.integrationlibrary_Id);
    formData.append("responseId", row.responseId);
    fetch(configData.api_url + "C_Integrationlibrary/downloadResponseJson", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          const csvContent = `${configData.api_url}${data.filePath}`;
          const link = document.createElement("a");
          link.setAttribute("href", csvContent);
          link.setAttribute("download", `responsejson.xlsx`); // Custom file name
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
  };
  Handledowloadcsv = (e, row) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", row.integrationlibrary_Id);
    formData.append("requestId", row.requestId);
    fetch(configData.api_url + "C_Integrationlibrary/downloadRequestJson", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);
        const csvContent = `${configData.api_url}${data.filePath}`;
        const link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute("download", `requestjson.xlsx`); // Custom file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  };
  AuthenticationmethodfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Authenticationmethod/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        var AuthenticationMethodKeys = {};
        var AuthenticationMethodAKeys = {};
        if (data.status === "success") {
          this.setState({ AuthenticationMethods: data.list });
          var i = 0;
          for (i = 0; i < data.list.length; i++) {
            var amFields = [];
            var amAFields = [];
            if (data.list[i].amFields !== "") {
              amFields = JSON.parse(JSON.parse(data.list[i].amFields));
              // console.log(amFields, typeof amFields);
            }
            if (data.list[i].amAFields !== "") {
              amAFields = JSON.parse(JSON.parse(data.list[i].amAFields));
              // console.log(amAFields, typeof amAFields);
            }
            // [{ "fieldName": "Token", "fieldType": "text", "defaultValues": "" }];
            // console.log(typeof amFields, "--", data.list[i].methodName);
            AuthenticationMethodKeys[data.list[i].methodName] = amFields;
            AuthenticationMethodAKeys[data.list[i].methodName] = amAFields;
            // console.log(AuthenticationMethodKeys);
            // console.log(AuthenticationMethodAKeys);
          }
          this.setState({
            AuthenticationMethodKeys: AuthenticationMethodKeys,
            AuthenticationMethodAKeys: AuthenticationMethodAKeys,
          });
        }
      });
  };
  // handleEditMode = (row) => {
  //   // this.setState({ cData: { ...row }, isEditing: true });
  //   var formData = new FormData();
  //   formData.append("sId", this.state.sId);
  //   formData.append("uId", this.state.uId);
  //   this.setState({
  //     type: row.type,
  //     partnerName: row.partnerName,
  //     ipUrl: row.ipUrl,
  //     amValues: row.amValues,
  //     apiName: row.apiName,
  //     inputMethod: row.inputMethod,
  //     authenticationMethod: row.authenticationMethod,
  //     eeId: row.eeId,
  //     inputHeaders: row.inputHeaders,
  //     integrationlibrary_Id: row.integrationlibrary_Id,
  //     apiDescription: row.apiDescription,
  //     isEditing: true,
  //   });
  // };
  handleEditMode = (row) => {
    const integrationlibrary_Id = row.integrationlibrary_Id;
    sessionStorage.setItem("isNewEntry", "false");

    sessionStorage.setItem("integrationlibrary_Id", integrationlibrary_Id);
    window.location.href = "/integration_library";
  };
  // offcanvas Open

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ isEditing: false });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };

  // header functionality
  keyvalidatehr() {
    const { currentStep, headerData } = this.state;
    let formIsValid = true;
    if (!headerData["key"]) {
      formIsValid = false;
      toast.info("*Enter Header Key.");
    } else if (!headerData["sampleValue"]) {
      formIsValid = false;
      toast.info("*Enter Header Sample value.");
    } else {
      // If all fields are filled, proceed to the next step
      this.setState({ currentStep: currentStep + 1 });
    }
    return formIsValid;
  }
  handleRemoveSpecificRowHeader = (idx) => {
    const tempRows = this.state.sendingHeader; // to avoid  direct state mutation
    tempRows.splice(idx, 1);
    this.setState({ sendingHeader: tempRows });
  };
  handleEditInputChangeHeader(index, field, value) {
    const updatedHeader = [...this.state.sendingHeader];
    updatedHeader[index][field] = value;
    // this.getColumns(value, "rcolumns");
    this.setState({ sendingHeader: updatedHeader });
  }
  inputSHrChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    const inputData = this.state.headerData;

    inputData[fieldName] = fieldValue;
    this.setState({ headerData: inputData });
    console.log(this.state.headerData);
  };
  IntegrationlibraryeditHandler = (e) => {
    e.preventDefault();
    // const updateFormData = {...editFormData};
    // updateFormData['Integrationlibrary_Id'] = e.target.parentElement.getAttribute("id");
    // setEditFormData(updateFormData);
    // setEdit(true);
  };
  renderTooltip = (text) => <Tooltip id="button-tooltip">{text}</Tooltip>;
  IntegrationlibraryfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Integrationlibrary/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  handledummyOneChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyOne: fieldValue });
  };
  IntegrationlibrarysubmitHandler = (e) => {
    e.preventDefault();
    var amValues = this.state.AuthenticationMethodValues;
    this.setState({ isSubmitted: true });
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integrationlibrary_Id", this.state.integrationlibrary_Id);
    formData.append("partnerName", this.state.partnerName);
    formData.append("apiName", this.state.apiName);
    formData.append("apiDescription", this.state.apiDescription);
    formData.append("ipUrl", this.state.ipUrl);
    formData.append("authenticationMethod", this.state.authenticationMethod);
    formData.append("amValues", JSON.stringify(amValues));
    formData.append("type", this.state.type);
    formData.append("inputMethod", this.state.inputMethod);
    formData.append("inputHeaders", JSON.stringify(this.state.sendingHeader));
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");
    formData.append("dummySix", "");
    formData.append("dummySeven", "");
    formData.append("dummyEight", "");
    formData.append("dummyNine", "");
    formData.append("dummyTen", "");
    fetch(configData.api_url + "C_Integrationlibrary/update", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          setTimeout(() => {
            window.location.href = "/requestjson";
          }, 1500);

          sessionStorage.setItem(
            "integrationlibrary_Id",
            data.integrationlibrary_Id
          );
          this.IntegrationlibraryfetchHandler();

          this.setState({
            integrationlibrary_Id: data.integrationlibrary_Id,
            partnerName: "",
            apiName: "",
            apiDescription: "",
            ipUrl: "",
            authenticationMethod: "",

            type: "",
          });
        }
      });
  };
  IntegrationlibraryupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("partnerName", this.state.partnerName);
    formData.append("apiName", this.state.apiName);
    formData.append("apiDescription", this.state.apiDescription);
    formData.append("ipUrl", this.state.ipUrl);
    formData.append("authenticationMethod", this.state.authenticationMethod);
    formData.append("token", this.state.token);
    formData.append("userName", this.state.userName);
    formData.append("pwd", this.state.pwd);
    formData.append("throttleLimit", this.state.throttleLimit);
    formData.append("type", this.state.type);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);
    formData.append("dummySix", this.state.dummySix);
    formData.append("dummySeven", this.state.dummySeven);
    formData.append("dummyEight", this.state.dummyEight);
    formData.append("dummyNine", this.state.dummyNine);
    formData.append("dummyTen", this.state.dummyTen);

    fetch(configData.api_url + "C_Integrationlibrary/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IntegrationlibraryfetchHandler();
          this.handleOffcanvasClose();
        }
      });
  };
  IntegrationtypemastersfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Integrationtypemasters/list", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ Integrationtype: data.list });
        }
      });
  };
  IntegrationlibraryfetchHandlerSaveJson = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };

  componentDidMount() {
    this.IntegrationlibraryfetchHandler();
    this.IntegrationtypemastersfetchHandler();
    this.AuthenticationmethodfetchHandler();
    this.IntegrationlibraryfetchHandlerSaveJson();
  }
  handleinputMethodChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ inputMethod: fieldValue });
  };

  handlepartnerNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ partnerName: fieldValue });
  };
  handleapiNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ apiName: fieldValue });
  };
  handleapiDescriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ apiDescription: fieldValue });
  };
  handleipUrlChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ipUrl: fieldValue });
  };
  handleauthenticationMethodChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    const amFields = this.state.AuthenticationMethodKeys[fieldValue];
    const amAFields = this.state.AuthenticationMethodAKeys[fieldValue];
    var AuthenticationMethodValues = {};
    var AuthenticationMethodAValues = {};
    amFields.forEach(function (key, index) {
      console.log(key);
      console.log(key["fieldName"]);
      AuthenticationMethodValues[key["fieldName"]] = "";
    });
    amAFields.forEach(function (key, index) {
      console.log(key);
      console.log(key["fieldName"]);
      AuthenticationMethodAValues[key["fieldName"]] = "";
    });
    console.log(AuthenticationMethodValues);
    console.log(AuthenticationMethodAValues);
    this.setState({
      authenticationMethod: fieldValue,
      amFields: amFields,
      amAFields: amAFields,
    });
  };
  handleJsonChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ jsonData: fieldValue });
  };
  generatePalceholder = (value1, value2) => {
    let returnValue = value1 + value2;
    // console.log(returnValue);
    return returnValue;
  };
  handletokenChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ token: fieldValue });
  };
  handleuserNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ userName: fieldValue });
  };
  handlepwdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pwd: fieldValue });
  };
  handlethrottleLimitChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ throttleLimit: fieldValue });
  };
  handletypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ type: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integrationlibrary_Id", row.integrationlibrary_Id);
    fetch(configData.api_url + "C_Integrationlibrary/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IntegrationlibraryfetchHandler();
        }
      });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  handleSubmitBackClick = (e) => {
    sessionStorage.setItem("isNewEntry", "true");
    window.location.href = "/integration_library";
  };
  handleinputAChange(fieldName, fieldType, fieldValue) {
    const AuthenticationMethodValues = this.state.AuthenticationMethodValues;
    fieldType = fieldName;
    AuthenticationMethodValues[fieldName] = fieldValue;
    this.setState({ AuthenticationMethodValues: AuthenticationMethodValues });
  }
  handleinputAAChange(fieldName, fieldType, fieldValue) {
    const AuthenticationMethodAValues = this.state.AuthenticationMethodAValues;
    fieldType = fieldName;
    AuthenticationMethodAValues[fieldName] = fieldValue;
    this.setState({ AuthenticationMethodAValues: AuthenticationMethodAValues });
  }

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        );
    // const { isSubmitted } = this.state;
    return (
      <div className="page-title">
        <Row>
          <Col xs={4} sm={4} lg={4}>
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Integration Library")}
            >
              <Card className="nav-card active-step">
                <span className="bi bi-boxes nav-icon"></span>
                <p className="nav-label">Integration Library</p>
              </Card>
            </OverlayTrigger>
          </Col>

          <Col xs={4} sm={4} lg={4}>
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Request JSON")}
            >
              <Card
                className="nav-card "
                onClick={() => this.setState({ step: 2 })}
              >
                <span className="bi bi-journal-album nav-icon"></span>
                <p className="nav-label">Request JSON</p>
              </Card>
            </OverlayTrigger>
          </Col>

          <Col xs={4} sm={4} lg={4}>
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Response JSON")}
            >
              <Card
                className="nav-card"
                onClick={() => this.setState({ step: 3 })}
              >
                <span className="bi bi-table nav-icon"></span>
                <p className="nav-label">Response JSON</p>
              </Card>
            </OverlayTrigger>
          </Col>
        </Row>
        <br />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                  dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Integration Library
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={() => this.setState({ isEditing: false })}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Integrationlibrary page
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Partner Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlepartnerNameChange}
                                        className="form-control"
                                        name="partnerName"
                                        value={this.state.partnerName}
                                        required="required"
                                        placeholder="Enter Partner Name"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        API Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        //disabled={isSubmitted}
                                        type="text"
                                        onChange={this.handleapiNameChange}
                                        className="form-control"
                                        name="apiName"
                                        value={this.state.apiName}
                                        required="required"
                                        placeholder="Enter API Name"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        API Description
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        //disabled={isSubmitted}
                                        type="text"
                                        onChange={
                                          this.handleapiDescriptionChange
                                        }
                                        className="form-control"
                                        name="apiDescription"
                                        value={this.state.apiDescription}
                                        required="required"
                                        placeholder="Enter API Description "
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        IP/URL
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        //disabled={isSubmitted}
                                        type="text"
                                        onChange={this.handleipUrlChange}
                                        className="form-control"
                                        name="ipUrl"
                                        value={this.state.ipUrl}
                                        required="required"
                                        placeholder="Enter IP/URL"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Integration Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        // disabled={isSubmitted}
                                        as="select"
                                        onChange={this.handletypeChange}
                                        className="form-select"
                                        name="type"
                                        value={this.state.type}
                                        required="required"
                                        placeholder="Enter Type"
                                      >
                                        <option defaultValue>
                                          Select Integration Type
                                        </option>
                                        {this.state.Integrationtype.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.typeName}
                                            >
                                              {api.typeName}
                                            </option>
                                          )
                                        )}
                                      </Form.Control>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Authentication Type
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        // disabled={isSubmitted}
                                        as="select"
                                        onChange={
                                          this.handleauthenticationMethodChange
                                        }
                                        className="form-select"
                                        name="authenticationMethod"
                                        value={this.state.authenticationMethod}
                                        required="required"
                                      >
                                        <option defaultValue>
                                          Select Type
                                        </option>
                                        {this.state.AuthenticationMethods.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.methodName}
                                            >
                                              {api.methodName}
                                            </option>
                                          )
                                        )}
                                      </Form.Control>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Select Method
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        aria-label="Default select example"
                                        name="inputMethod"
                                        value={this.state.inputMethod}
                                        onChange={this.handleinputMethodChange}
                                      >
                                        <option>Select method</option>
                                        <option value="GET">GET</option>
                                        <option value="POST">POST</option>
                                        <option value="PUT">PUT</option>
                                        <option value="PATCH">PATCH</option>
                                        <option value="DELETE">DELETE</option>
                                        <option value="LINK">LINK</option>
                                        <option value="LINK">UNLINK</option>
                                        <option value="HEAD">HEAD</option>
                                        <option value="PURGE">PURGE</option>
                                        <option value="LOCK">LOCK</option>
                                        <option value="UNLOCK">UNLOCK</option>
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyThree}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {this.state.amFields.length > 0 ? (
                                    <Card>
                                      <Row>
                                        <Col>
                                          <div className="row">
                                            {this.state.amFields.map(
                                              (api, index, idx) => (
                                                <div
                                                  className="col-md-4 col-lg-6"
                                                  key={idx}
                                                >
                                                  <Form.Label
                                                    style={{
                                                      paddingTop: "8px",
                                                    }}
                                                  >
                                                    {api.labelName}
                                                  </Form.Label>
                                                  {api.fieldType ===
                                                  "checkbox" ? (
                                                    <Form.Check
                                                      type={api.fieldType}
                                                      className="form-check"
                                                      name={api.fieldName}
                                                      onChange={(e) =>
                                                        this.handleinputAChange(
                                                          api.fieldName,
                                                          api.fieldType,
                                                          e.target.value
                                                        )
                                                      }
                                                      placeholder={this.generatePalceholder(
                                                        "Enter ",
                                                        api.labelName
                                                      )}
                                                    />
                                                  ) : api.fieldType !==
                                                    "select" ? (
                                                    <Form.Control
                                                      type={api.fieldType}
                                                      className="form-control"
                                                      name={api.fieldName}
                                                      onChange={(e) =>
                                                        this.handleinputAChange(
                                                          api.fieldName,
                                                          api.fieldType,
                                                          e.target.value
                                                        )
                                                      }
                                                      placeholder={this.generatePalceholder(
                                                        "Enter ",
                                                        api.labelName
                                                      )}
                                                    />
                                                  ) : (
                                                    <Form.Control
                                                      as={api.fieldType}
                                                      className="form-select"
                                                      placeholder={this.generatePalceholder(
                                                        "Select ",
                                                        api.fieldName
                                                      )}
                                                      value={
                                                        this.state
                                                          .AuthenticationMethodAValues[
                                                          api.fieldName
                                                        ]
                                                      } // Assuming 'token' is the state variable for the text box
                                                      onChange={(e) =>
                                                        this.handleinputAChange(
                                                          api.fieldName,
                                                          api.fieldType,
                                                          e.target.value
                                                        )
                                                      } // Update the token value in state
                                                    >
                                                      {api.defaultValues
                                                        .split(",")
                                                        .map((line) => (
                                                          <option value={line}>
                                                            {line}
                                                          </option>
                                                        ))}
                                                    </Form.Control>
                                                  )}
                                                  <br />
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </Col>
                                      </Row>
                                    </Card>
                                  ) : (
                                    ""
                                  )}
                                  {this.state.amAFields.length > 0 ? (
                                    <Card>
                                      <Row>
                                        <Col>
                                          <div className="row">
                                            {this.state.amAFields.map(
                                              (api, index, idx) => (
                                                <div className="col-md-4 col-lg-6">
                                                  <Form.Label
                                                    style={{
                                                      paddingTop: "8px",
                                                    }}
                                                  >
                                                    {api.fieldName} --{" "}
                                                    {api.fieldName}
                                                  </Form.Label>
                                                  {api.fieldType ===
                                                  "checkbox" ? (
                                                    <Form.Check
                                                      checked={
                                                        this.state
                                                          .AuthenticationMethodAValues[
                                                          api.fieldName
                                                        ] || false
                                                      }
                                                      type="checkbox"
                                                      className="form-check"
                                                      name={api.fieldName}
                                                      onChange={(e) =>
                                                        this.handleinputAAChange(
                                                          api.fieldName,
                                                          api.fieldType,
                                                          e.target.checked
                                                        )
                                                      }
                                                      placeholder={this.generatePalceholder(
                                                        "Enter ",
                                                        api.fieldName
                                                      )}
                                                    />
                                                  ) : api.fieldType !==
                                                    "select" ? (
                                                    <Form.Control
                                                      type={api.fieldType}
                                                      className="form-control"
                                                      name={api.fieldName}
                                                      onChange={(e) =>
                                                        this.handleinputAAChange(
                                                          api.fieldName,
                                                          api.fieldType,
                                                          e.target.value
                                                        )
                                                      }
                                                      placeholder={this.generatePalceholder(
                                                        "Enter ",
                                                        api.fieldName
                                                      )}
                                                    />
                                                  ) : (
                                                    <Form.Control
                                                      as={api.fieldType}
                                                      className="form-select"
                                                      placeholder={this.generatePalceholder(
                                                        "Select ",
                                                        api.fieldName
                                                      )}
                                                      value={
                                                        this.state
                                                          .AuthenticationMethodAValues[
                                                          api.fieldName
                                                        ]
                                                      } // Assuming 'token' is the state variable for the text box
                                                      onChange={(e) =>
                                                        this.handleinputAAChange(
                                                          api.fieldName,
                                                          api.fieldType,
                                                          e.target.value
                                                        )
                                                      } // Update the token value in state
                                                    >
                                                      {api.defaultValues
                                                        .split(",")
                                                        .map((line) => (
                                                          <option value={line}>
                                                            {line}
                                                          </option>
                                                        ))}
                                                    </Form.Control>
                                                  )}
                                                  <br />
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </Col>
                                      </Row>
                                    </Card>
                                  ) : (
                                    ""
                                  )}
                                  <br />{" "}
                                  <Card>
                                    <Card.Header>Headers</Card.Header>
                                    <Card.Body>
                                      <Table
                                        className="table table-bordered table-hover"
                                        id="tab_logic"
                                      >
                                        <thead>
                                          <tr>
                                            <th className="text-center">
                                              S.NO
                                            </th>
                                            <th className="text-center">KEY</th>

                                            <th className="text-center">
                                              Sample
                                            </th>
                                            <th className="text-center">
                                              Actions
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.sendingHeader.length >
                                          0 ? (
                                            this.state.sendingHeader.map(
                                              (api, index, idx) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    {this.state.editingIndex ===
                                                    index ? (
                                                      <Form.Control
                                                        type="Text"
                                                        value={api.key}
                                                        onChange={(e) =>
                                                          this.handleEditInputChangeHeader(
                                                            index,
                                                            "key",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      api.key
                                                    )}
                                                  </td>

                                                  <td>
                                                    {this.state.editingIndex ===
                                                    index ? (
                                                      <Form.Control
                                                        type="Text"
                                                        name="sampleValue"
                                                        placeholder="Sample"
                                                        value={api.sampleValue}
                                                        onChange={(e) =>
                                                          this.handleEditInputChangeHeader(
                                                            index,
                                                            "sampleValue",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      api.sampleValue
                                                    )}
                                                  </td>
                                                  <td>
                                                    {this.state.editingIndex !==
                                                      index && ( // Condition to render Add button above the row being edited
                                                      <button
                                                        variant="danger"
                                                        className="bi bi-trash-fill btn btn-danger"
                                                        onClick={() =>
                                                          this.handleRemoveSpecificRowHeader(
                                                            index
                                                          )
                                                        }
                                                      ></button>
                                                    )}
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td colSpan="6"> No Records</td>
                                            </tr>
                                          )}
                                          <tr>
                                            <td>---</td>
                                            <td>
                                              <Form.Control
                                                type="Text"
                                                name="key"
                                                placeholder="Key Value"
                                                value={
                                                  this.state.headerData.key
                                                }
                                                onChange={this.inputSHrChange}
                                              />
                                              <div
                                                className="errorMsg"
                                                style={{ color: "red" }}
                                              >
                                                {this.state.errors.key}
                                              </div>
                                            </td>

                                            <td>
                                              <Form.Control
                                                type="Text"
                                                name="sampleValue"
                                                placeholder="Sample Value"
                                                value={
                                                  this.state.headerData
                                                    .sampleValue
                                                }
                                                onChange={this.inputSHrChange}
                                              />
                                            </td>
                                            <td>
                                              <Button
                                                type="button"
                                                variant="success"
                                                // className="bi bi-plus"
                                                onClick={this.addSendhrRow}
                                              >
                                                Add
                                              </Button>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </Table>
                                    </Card.Body>
                                  </Card>{" "}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.IntegrationlibrarysubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Update
                                </Button>
                              </Col>
                            </Row>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        onClick={this.handleSubmitBackClick}
                        style={{ float: "right", marginBottom: "10px" }}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        paginationRowsPerPageOptions={[
                          10, 20, 30, 50, 60, 70, 80, 90, 100, 150, 200,
                        ]}
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationPerPage={this.state.itemsPerPage}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
